/**
 * @generated SignedSource<<281e7f9f158c9161e984827e0ba804f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InfoLink_infoLink$data = {
  readonly header: string | null | undefined;
  readonly infotext: string | null | undefined;
  readonly key: string | null | undefined;
  readonly linktext: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "InfoLink_infoLink";
};
export type InfoLink_infoLink$key = {
  readonly " $data"?: InfoLink_infoLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"InfoLink_infoLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InfoLink_infoLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "infotext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linktext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "type": "InfoLink",
  "abstractKey": null
};

(node as any).hash = "aab529d6b948844ed03b536654307402";

export default node;
